import {
  ColumnsModel,
  QueryBuilderComponent,
} from "@syncfusion/ej2-react-querybuilder";
import {
  ChangeEventArgs as NumberChangeEventArgs,
  NumericTextBox,
} from "@syncfusion/ej2-react-inputs";
import {
  ChangedEventArgs as DateChangeEventArgs,
  DatePicker,
} from "@syncfusion/ej2-react-calendars";
import {
  equalOperator,
  notEqualOperator,
  lessOrEqualOperator,
  greaterOperator,
  greaterOrEqualOperator,
  lessOperator,
} from ".";
import { getComponent } from "@syncfusion/ej2-base";
import React from "react";
import { parse } from "date-fns";

export class DateColumn {
  constructor(
    private column: ColumnsModel,
    private queryBuilderRef: React.RefObject<QueryBuilderComponent | null>
  ) { }

  DateIsBeforeAfterOperator = {
    key: "Date Is Before/After Today",
    value: "beforeafter",
  };

  Operator = [
    equalOperator,
    notEqualOperator,
    greaterOperator,
    greaterOrEqualOperator,
    lessOperator,
    lessOrEqualOperator,
    this.DateIsBeforeAfterOperator,
  ];

  ToColumn(): ColumnsModel {
    let elem: HTMLElement;
    let numberComponent: NumericTextBox;
    let dateComponent: DatePicker;

    return {
      ...this.column,
      operators: this.Operator,
      template: {
        create: () => {
          elem = document.createElement("input");
          elem.setAttribute("type", "text");
          return elem;
        },
        destroy: (args: { elementId: string }) => {
          numberComponent = getComponent(
            document.getElementById(args.elementId) as HTMLElement,
            "NumericTextBoxComponent"
          ) as NumericTextBox;
          if (numberComponent) {
            numberComponent.destroy();
          }

          dateComponent = getComponent(
            document.getElementById(args.elementId) as HTMLElement,
            "NumericTextBoxComponent"
          ) as DatePicker;
          if (dateComponent) {
            dateComponent.destroy();
          }
        },
        write: (args: {
          elements: Element;
          values: string[] | string;
          operator: string;
        }) => {
          switch (args.operator) {
            case "beforeafter":
              numberComponent = new NumericTextBox({
                value:
                  typeof args.values === "number"
                    ? args.values
                    : parseInt(args.values as string, 10),
                showSpinButton: false,
                format: "n0",
                min: -365,
                max: 365,
                change: (e: NumberChangeEventArgs) => {
                  if (
                    e.value !== null &&
                    e.value !== undefined &&
                    e.event?.srcElement
                  ) {
                    this.queryBuilderRef.current?.notifyChange(
                      e.value.toString(),
                      e.event?.srcElement as Element
                    );
                  }
                },
              });

              numberComponent.appendTo("#" + args.elements.id);

              break;
            default:
              dateComponent = new DatePicker({
                value:
                  typeof args.values === "string"
                    ? parse(args.values, "yyyy-MM-dd", new Date())
                    : (null as unknown as Date),
                change: (e: DateChangeEventArgs) => {
                  if (e.value && e.element) {
                    this.queryBuilderRef.current?.notifyChange(
                      e.value.toISOString().split("T")[0],
                      e.element as Element
                    );
                  }
                },
              });
              dateComponent.appendTo("#" + args.elements.id);
          }
        },
      },
    };
  }
}
